import { computed } from 'vue';
import { useStore } from '@dh-io-otb/shared/src/composables/store.composable';
import { TestDriveMode } from '@dh-io-otb/shared/src/models/utilities/testdrive-mode.enum';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars
const useCalendarPeriodItem = (props, { emit }) => {
  const { state } = useStore();
  // ----------------------------------------
  // computed
  const checkedClass = computed(() => {
    if (state.otbcFlow.testDriveMode === TestDriveMode.BOOKING) {
      return { 'otb-calendar-period-item-booking--checked': isChecked.value };
    }
    return { 'otb-calendar-period-item--checked': isChecked.value };
  });

  const isChecked = computed((): boolean => {
    return props.option.value.periodId
      ? props.option.value.periodId === props.value.periodId
      : props.option.value.label === props.value.label;
  });

  const optionName = computed((): string => {
    return props.option.value.periodId || props.option.value.label;
  });

  // ----------------------------------------
  // methods
  const input = (val: boolean): void => {
    emit('input', val);
  };

  return {
    checkedClass,
    input,
    isChecked,
    optionName,
  };
};

export default useCalendarPeriodItem;
